module.exports = __webpack_public_path__ + "static/media/apartment12.a1d60f4e.jpg";